import { Link } from "gatsby"
import React from "react"

import { Row, Col } from "react-bootstrap"

import { formatDate } from "../../../utils/format-date-time"

import "./title.scss"

const Title = ({ articles }) => {
  const title = articles[0]._embedded["wp:term"][0][0]

  const getContent = text => {
    return {
      __html: text,
    }
  }
  const title_text = articles[0]?.title?.rendered
  const getUrl = () => {
    if (typeof window !== undefined) {
      return window.location.href
    }
  }
  return (
    <div className="blog-title ">
      <h1
        className="blog-detail-title mb-3"
        dangerouslySetInnerHTML={getContent(title_text)}
      ></h1>
      <div className="category-social-section mb-3">
        {/* border-bottom for stat */}
        <Row>
          <Col sm="9" xs={12}>
            <div className="category">
              <span className="category-name">
                <Link to={`/blog/category/` + title.slug}>{title.name}</Link>
              </span>
              <span className="gap"> | </span>
              <span>{formatDate(articles[0].date)} </span>
              <span className="gap"> | </span>
              <span>By: {articles[0]._embedded.author[0].name}</span>
            </div>
          </Col>
          <Col sm="3" xs={12} className="text-sm-right text-left mt-2 mt-sm-0">
            <div className="social">
              <span className="">Share:</span>
              <a
                href={`https://www.facebook.com/sharer.php?u=${getUrl()}`}
                target="_blank"
                rel="noreferrer"
              >
                <i className="ml-2 fab fa-facebook-f"></i>
              </a>
              <a
                href={`https://www.twitter.com/intent/tweet?text=${getUrl()}`}
                target="_blank"
                rel="noreferrer"
              >
                <i className="ml-2 fab fa-twitter"></i>
              </a>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default Title
